import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Button, Stack } from '@lyearn/ui';
import { Modal } from '@/components/Modals';
import VideoPlayer from '@/components/VideoPlayer';
import { CharacterAvatarType } from '@/types/schema';

interface AvatarPreviewModalProps {
  avatar: CharacterAvatarType;
  onClose: () => void;
  onChoose: () => void;
}

const AvatarPreviewModal = ({ avatar, onClose, onChoose }: AvatarPreviewModalProps) => {
  const { t } = useTranslation('Course');

  return (
    <Modal
      showCloseIcon
      classes={{ paper: '!w-[702px] !min-h-0' }}
      footer={
        <Stack
          alignItems="center"
          className="border-t border-border px-24 py-12"
          direction="row"
          gap={12}
          justifyContent="end">
          <Button size="medium" variant="outlined" onClick={onClose}>
            {t('Common:Actions.Close')}
          </Button>
          <Button size="medium" variant="filled" onClick={onChoose}>
            {t('Course:AiVideoGeneration.ChooseThisAvatar')}
          </Button>
        </Stack>
      }
      header={{ title: t('Course:AiVideoGeneration.AvatarPreview') }}
      onClose={onClose}>
      <Stack className="px-28 pt-16" direction="col">
        {avatar.preview_video_url ? (
          <div key={avatar.avatar_id}>
            <VideoPlayer autoplay url={avatar.preview_video_url} />
          </div>
        ) : null}
      </Stack>
    </Modal>
  );
};

export default AvatarPreviewModal;
